;(() => {
    window.mapsReady = function () {
        const event = new Event('mapsReady')
        window.dispatchEvent(event)
    }

    const GooglePlacesAPIKey = document.querySelector('#GOOGLE_MAPS_FRONTEND').value

    var script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GooglePlacesAPIKey}&libraries=places&callback=mapsReady`
    script.async = true
    document.head.appendChild(script)
})()
